function formatoRut(persona) {
  if (persona) {
    if (persona.tipoIdentificacion == 'C') {
      return `${persona.numeroIdentificacion} - ${persona.dv}`;
    }
    if (persona.tipoIdentificacion == 'P') {
      return `${persona.tipoIdentificacion}  ${persona.numeroIdentificacion}`;
    }
    if (persona.tipoIdentificacion == 'I') {
      return `IPE ${persona.numeroIdentificacion}`;
    }
  }
  return '';
}

function nombreCompleto(persona) {
  return persona ? `${persona.nombres} ${persona.paterno} ${persona.materno}` : '';
}

function nombreCompletoApellidosPrimero(persona) {
  return persona ? `${persona.paterno} ${persona.materno} ${persona.nombres}` : '';
}

function codigosFunciones() {
  return [2, 3, 4, 5, 6, 9];
}

function puedeModificar(vigencia, rol, funcion) {
  //ROL 1= DELEGADO 2= JEFE LOCAL 3= COLABORADOR
  //FUNCION 1= DELEGADO 2= JEFE DE LOCAL
  return  vigencia && ((rol == 2 || rol == 3 || rol == 4) && funcion != 1) || (rol == 1 && funcion == 1);
}

function puedeEliminar(vigencia, rol, funcion) {
  //ROL 2= JEFE LOCAL 3= COLABORADOR
  //FUNCION 1= DELEGADO 2= JEFE DE LOCAL
  return  vigencia && ((rol == 2 || rol == 3 || rol == 4) && (funcion != 1 && funcion != 2));
}

function getOrdenSala(tipoSala, salas) {
  let sala = { nroSala: 1, orden: 1};
  let fnFilter = (val) => val < 51;
  if (tipoSala == 2) {
    sala = { nroSala: 51, orden: 51};
    fnFilter = (val) => val > 50 && val < 90;
  }
  const secuencias = salas.map(sala => sala.nroSala).filter(fnFilter);
  if (secuencias.length) {
    sala = {
      nroSala: Math.max(...secuencias) + 1,
      orden: secuencias.length + (tipoSala == 1 ? 1 : 51)
    };
  }
  return sala;
}

function moduloFaseAbierto(modulo, fase) {
  const modulos = window.DATA.modulos;
  return modulos.find(m => m.idModulo == modulo)?.fase.some(({fspCodigo}) => fspCodigo == fase);
}

const arrayToObject = (array, fxKey, fxValue) =>
  array.reduce ((obj, item) => {
    obj [fxKey(item)] = fxValue(item);
    return obj;
  }, {});

module.exports = {
  formatoRut,
  nombreCompleto,
  nombreCompletoApellidosPrimero,
  codigosFunciones,
  puedeModificar,
  puedeEliminar,
  getOrdenSala,
  moduloFaseAbierto,
  arrayToObject,
};
